var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"right-content mx-auto my-auto w-50 otp-card"},[_c('OtpModal',{attrs:{"isMain":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }